import request from '@/utils/request';
function transformItem2Dto(item) {
  const dto = {
    ...item,
    code: item.notificationCode
  };
  delete dto.notificationCode;
  return dto;
}

export function apiBlockNotification(item) {
  return request({
    data: transformItem2Dto(item),
    method: 'post',
    url: '/notification/block'
  });
}
